import React from 'react';
import LazyLoad from '../../common/components/LazyLoad';
import LegacyUserResource from '../../common/resource/LegacyUserResource';
import { Icon } from '../../common/components/Utilities';

const RelativeTime = ({ mins }) => {
  const formatter = Intl.NumberFormat('en-GB', { maximumFractionDigits: 1 });

  if (mins >= 924) {
    return `${formatter.format(mins / 462)} days`;
  }

  if (mins >= 120) {
    return `${formatter.format(mins / 60)} hours`;
  }

  return `${mins} minutes`;
};

export default function ({ user, start, end }) {
  return (
    <LazyLoad
      resourceAction={LegacyUserResource.timeSpent}
      params={[user, start, end]}
      defaultData={0}
      render={(loading, { average, count }) => {
        if (loading) {
          return <Icon icon="circle-notch" variant="fad" append="fa-spin text-info" fixed />;
        }

        if (average === 0 || count === 0) {
          return <div className="text-muted text-italic">Not enough data.</div>;
        }

        return (
          <>
            <div>
              <RelativeTime mins={average} />
            </div>
            <div className="small text-muted">
              {`Based on ${count} tickets.`}
            </div>
          </>
        );
      }}
    />
  );
}
